import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
    faUserSecret, 
    faUser, 
    faCheck, 
    faTimes, 
    faEye, 
    faCog, 
    faFolderOpen, 
    faSignOut, 
    faFile, 
    faCloudUpload, 
    faChartLine, 
    faFileWord, 
    faFileExcel, 
    faFilePdf,
    faFileImage,
    faEyeSlash, 
    faCalendarAlt,
    faInboxIn,
    faFolderDownload,
    faAngleDoubleRight,
    faHdd,
    faDownload,
    faReply,
    faArchive,
    faTrashAlt,
    faChevronCircleLeft,
    faKey,
    faSpinner
} from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

//Add font-awesome components
library.add(faUserSecret)
library.add(faCheck)
library.add(faTimes)
library.add(faEye)
library.add(faCog)
library.add(faFolderOpen)
library.add(faSignOut)
library.add(faFile)
library.add(faCloudUpload)
library.add(faChartLine)
library.add(faFileWord)
library.add(faFileExcel)
library.add(faFilePdf)
library.add(faFileImage)
library.add(faEyeSlash)
library.add(faCalendarAlt)
library.add(faInboxIn)
library.add(faFolderDownload)
library.add(faAngleDoubleRight)
library.add(faHdd)
library.add(faDownload)
library.add(faReply)
library.add(faArchive)
library.add(faTrashAlt)
library.add(faChevronCircleLeft)
library.add(faUser)
library.add(faKey)
library.add(faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false


// WEBPACK FOOTER //
// ./src/fontawesome.js